import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import TestPage from "./screens/TestPage/TestPage";
import VerifyEmail from "./screens/VerifyEmail/VerifyEmail";
import ProfilePage from "./screens/ProfilePage/ProfilePage";
import AdminPage from "./screens/AdminPage/AdminPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Header from "./components/Header/Header";
import { ConsentProvider } from "./consent/ConsentProvider";
import AnalyticsLoader from "./analytics/AnalyticsLoader";
import AppFooter from "./components/AppFooter/AppFooter";
import HomePage from "./screens/HomePage/HomePage";
import CennikPage from "./screens/CennikPage/CennikPage";
import KontaktPage from "./screens/KontaktPage/KontaktPage";
import RozvrhPage from "./screens/RozvrhPage/RozvrhPage";
import SiteGate from "./components/SiteGate/SiteGate";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ErrorModal from "./components/ErrorModal/ErrorModal";
import GdprPage from "./screens/Gdpr/GdprPage";
import VopPage from "./screens/Vop/VopPage";
import CookiesPage from "./screens/Cookies/CookiesPage";

function ProtectedRoute({ children }) {
  const { isLoggedIn, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isLoggedIn) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { isLoggedIn, isAdmin, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isLoggedIn || !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const location = useLocation();
  const hideFooter =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/profil");
  return (
    <SiteGate active={window.location.hostname !== "capoeira.sk"}>
      <ConsentProvider>
        <AuthProvider>
          <ScrollToTop />
          <ErrorModal />
          <div className="App">
            {/* Header */}
            <Header logo="CAPOEIRA - professor Fogo" />

            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="o-nas" element={<HomePage />} />
              <Route path="cennik" element={<CennikPage />} />
              <Route path="kontakt" element={<KontaktPage />} />
              <Route path="rozvrh" element={<RozvrhPage />} />
              <Route
                path="profil"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin"
                element={
                  <AdminRoute>
                    <AdminPage />
                  </AdminRoute>
                }
              />
              <Route path="test" element={<TestPage />} />
              <Route path="verify-email" element={<VerifyEmail />} />
              <Route path="ochrana-osobnych-udajov" element={<GdprPage />} />
              <Route
                path="vseobecne-obchodne-podmienky"
                element={<VopPage />}
              />
              <Route path="cookie-politika" element={<CookiesPage />} />
              <Route path="*" element={<h1>Stránka nenalezena</h1>} />
            </Routes>
            {!hideFooter && <AppFooter />}
          </div>
          <AnalyticsLoader />
        </AuthProvider>
      </ConsentProvider>
    </SiteGate>
  );
}

export default App;
